/* eslint-disable react/no-array-index-key */

import React from 'react'
import PropTypes from 'prop-types'
import IframeViewer from 'components/IframeViewer'
import Alert from 'components/Alert'
import { getEmployeeId } from 'utils/getEmployeeId'
import classnames from 'classnames'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./AccountsAndLoans.scss'),
)

class AccountTransactionsView extends React.Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    selectedPartner: null,
    currentUser: null,
  }

  render() {
    const { accountsAndLoans, currentUser, selectedPartner } = this.props
    const reportUrl = (accountsAndLoans.selectedAccount.AccountType === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.PRE_SWIFT
      ? constants.ACCOUNTSANDLOANS.PRE_SWIFT_TRX_REPORT_URL
      : constants.ACCOUNTSANDLOANS.POST_SWIFT_TRX_REPORT_URL)
    const accountNo = (accountsAndLoans.selectedAccount.AccountType === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.PRE_SWIFT
      ? accountsAndLoans.selectedAccount.AccountNo
      : accountsAndLoans.selectedAccount.AccountId)

    return (
      <div className={styles.content}>
        <div className={styles.sectionAlertTrx}>
          <Alert type="info">
            {constants.ACCOUNTSANDLOANS.TRANSACTION_INFO.LABEL1}<br />{constants.ACCOUNTSANDLOANS.TRANSACTION_INFO.LABEL2}
          </Alert>
        </div>
        <section className={classnames(styles.section, styles.sectionFrame)}>
          <IframeViewer
            title={`Account No. ${accountsAndLoans.selectedAccount.AccountNo} - ${accountsAndLoans.selectedAccount.LegalName}`}
            url={`${reportUrl}&P=${getEmployeeId(selectedPartner, currentUser)}&A=${accountNo}`}
          />
        </section>
      </div>
    )
  }
}

export default AccountTransactionsView



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/AccountTransactions.js